import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-question-gray.svg'
import _imports_1 from '@/assets/icons/arrow-up-landing.svg'


const _hoisted_1 = { class: "main-wr" }
const _hoisted_2 = { class: "calculator-wr" }
const _hoisted_3 = { class: "controls-wr" }
const _hoisted_4 = { class: "input-wr" }
const _hoisted_5 = { class: "input-default" }
const _hoisted_6 = { class: "input-text" }
const _hoisted_7 = { class: "deposit-wr" }
const _hoisted_8 = { class: "deposit-buttons-wr" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "input-wr" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "input-wr" }
const _hoisted_13 = { class: "input-default" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "input-wr" }
const _hoisted_16 = { class: "content-input" }
const _hoisted_17 = { class: "result-and-assumptions-wr" }
const _hoisted_18 = {
  key: 0,
  class: "content-button-calculate"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 1,
  class: "content-estimated-and-buttons"
}
const _hoisted_21 = { class: "text-estimated" }
const _hoisted_22 = { class: "result-estimated" }
const _hoisted_23 = { class: "form-group-dropdown" }
const _hoisted_24 = {
  class: "dropdown-button input-dropdown input-modified",
  type: "button"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 2,
  class: "content-estimated-and-buttons-mobile"
}
const _hoisted_27 = { class: "content-estimated-and-dropdown" }
const _hoisted_28 = { class: "result-estimated" }
const _hoisted_29 = { class: "form-group-dropdown" }
const _hoisted_30 = {
  class: "dropdown-button input-dropdown input-modified",
  type: "button"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "icon-question",
  src: _imports_0
}
const _hoisted_33 = {
  key: 1,
  class: "icon-arrow",
  src: _imports_1
}
const _hoisted_34 = {
  key: 0,
  class: "content-button-calculate-mobile"
}
const _hoisted_35 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title" }, "My Repayments", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "Package Price", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString($setup.formatPrice($setup.props.packagePrice, true)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label" }, "Deposit", -1)),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0.05, 0.1, 0.2], (depositValue) => {
              return _createElementVNode("button", {
                class: _normalizeClass(["button primary deposit-button", { active: $setup.depositPercentage === depositValue }]),
                key: depositValue,
                onClick: ($event: any) => ($setup.selectDeposit(depositValue))
              }, _toDisplayString(depositValue * 100) + "%", 11, _hoisted_9)
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label" }, "Loan Amount", -1)),
          _createElementVNode("input", {
            class: "input-default",
            type: "text",
            value: $setup.formatPrice($setup.calculatedLoanAmount, true),
            readonly: ""
          }, null, 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Loan Term", -1)),
          _createVNode($setup["DropDown"], null, {
            control: _withCtx(() => [
              _createElementVNode("label", _hoisted_13, _toDisplayString(`${$setup.loanTerm} years` || "Select Template"), 1)
            ]),
            dropdown: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([30, 25, 20, 15, 10, 5], (time) => {
                return _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    onClick: ($event: any) => ($setup.loanTerm = time),
                    class: _normalizeClass({ 'dropdown__item-active': time === $setup.loanTerm })
                  }, _toDisplayString(`${time} years`), 11, _hoisted_14)
                ])
              }), 64))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label" }, "Interest Rate", -1)),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              type: "number",
              step: "0.1",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.interestRate) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.handleInterestChange($event.target.value)))
            }, null, 544), [
              [_vModelText, $setup.interestRate]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "percentage" }, "%", -1))
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_17, [
          ($setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("a", {
                  class: "button default primary result",
                  href: `/builder/estate/${$setup.estateId}/borrow-calculator/request-quote/${$setup.props.quote._id}`,
                  target: "_blank"
                }, "Calculate my Borrowing Capacity", 8, _hoisted_19)
              ]))
            : _createCommentVNode("", true),
          ($setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[10] || (_cache[10] = _createTextVNode("Estimated Repayments:", -1)),
                  _createElementVNode("div", _hoisted_22, _toDisplayString($setup.formatPrice($setup.calculateRepayments(), true)), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", null, [
                    _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
                      control: _withCtx(() => [
                        _createElementVNode("label", _hoisted_24, _toDisplayString($setup.selectedTimePeriod), 1)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.timePeriod, (period) => {
                            return _createElementVNode("li", {
                              key: period,
                              onClick: ($event: any) => ($setup.selectTimePeriod(period)),
                              class: _normalizeClass({ 'dropdown__item-active': period === $setup.selectedTimePeriod })
                            }, _toDisplayString(period), 11, _hoisted_25)
                          }), 64))
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("button", {
                  class: _normalizeClass(["dropdown-button assumptions", { active: $setup.fadeInEffect }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openAssumptions()))
                }, "Assumptions", 2)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-estimated" }, "Estimated Repayments:", -1)),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString($setup.formatPrice($setup.calculateRepayments(), true)), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", null, [
                      _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
                        control: _withCtx(() => [
                          _createElementVNode("label", _hoisted_30, _toDisplayString($setup.selectedTimePeriod), 1)
                        ]),
                        dropdown: _withCtx(() => [
                          _createElementVNode("ul", null, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.timePeriod, (period) => {
                              return _createElementVNode("li", {
                                key: period,
                                onClick: ($event: any) => ($setup.selectTimePeriod(period)),
                                class: _normalizeClass({ 'dropdown__item-active': period === $setup.selectedTimePeriod })
                              }, _toDisplayString(period), 11, _hoisted_31)
                            }), 64))
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "button default primary message",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openAssumptions()))
                }, [
                  _cache[11] || (_cache[11] = _createTextVNode("Assumptions", -1)),
                  (!$setup.fadeInEffect)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_32))
                    : (_openBlock(), _createElementBlock("img", _hoisted_33))
                ])
              ])),
          _createVNode($setup["BuilderLoanAssumptions"], {
            isOpen: $setup.isAssumptionsOpen,
            class: _normalizeClass({ isOpen: $setup.fadeInEffect })
          }, null, 8, ["isOpen", "class"])
        ])
      ])
    ]),
    (!$setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("button", {
            class: "button default primary result",
            href: `/builder/estate/${$setup.estateId}/borrow-calculator/request-quote/${$setup.props.quote._id}`,
            target: "_blank"
          }, "Calculate my Borrowing Capacity", 8, _hoisted_35)
        ]))
      : _createCommentVNode("", true),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-info" }, "Note: The information provided by the calculator is intended to provide illustrative examples based on stated assumptions and your inputs. Calculations are meant as estimates only and it is advised that you consult with a mortgage broker about your specific circumstances.", -1))
  ]))
}